import { useMutation, useQueryClient } from '@tanstack/react-query';

import { overrideOrganizationHeader, parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';

import { apiClient } from '@cast/infrastructure-api';
import { ORGANIZATIONS_QUERY_KEY } from '@cast/infrastructure-organization';

type InviteMember = {
  userEmail: string;
};

export const useInviteOrganizationMutation = (orgId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: InviteMember[]) =>
      apiClient.user.createInvitation(
        {
          body: { members: payload },
        },
        orgId ? { headers: overrideOrganizationHeader(orgId) } : undefined
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ORGANIZATIONS_QUERY_KEY],
      });
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
